export enum CommonRoutesPaths {
  Parse = '/parse',
  BullhornParse = '/bullhorn-parse',
  GorillaWorksResumeBuilder = '/gorillaworks-resume-copilot',
  GorillaWorksBullhornResumeBuilder = '/gorillaworks-bullhorn',
  ProcomResumeBuilder = '/resume-copilot-pro',
  ProcomBullhornResumeBuilder = '/bullhorn-resume-copilot',
  AplinResumeBuilder = '/aplin-resume-copilot',
  EastWestStaffingResumeBuilder = '/eastweststaffing-resume-copilot',
  IMethodsResumeBuilder = '/imethods-resume-copilot',
  IMethodsBullhornResumeBuilder = '/imethods-bullhorn',
  MedmasaResumeBuilder = '/medmasa-resume-copilot',
  BeaconHillStaffingResumeBuilder = '/beaconhillstaffing-resume-copilot',
  WestCorpResumeBuilder = '/westcorp-resume-copilot',
  CustomStaffingResumeBuilder = '/customstaffing-resume-copilot',
  CustomStaffingBullhornResumeBuilder = '/customstaffing-bullhorn',
  NewburyResumeBuilder = '/newbury-resume-copilot',
  NewburyBullhornResumeBuilder = '/newbury-bullhorn',
  AplinBullhornResumeBuilder = '/aplin-bullhorn',
  HRProjectPartnersResumeBuilder = '/hrprojectpartners-resume-copilot',
  JoinOrganization = '/join-organization',
  Upgrade = '/upgrade',
  AccessDenied = '/access-denied',
  Organization = '/organization',
  PrivacyPolicy = '/privacy-policy',
  TermsOfUse = '/terms-of-use',
  UsersAndTeams = '/users-and-teams',
  Templates = '/templates',
  Admin = '/admin/*',
  PricingAndPlans = '/pricing-and-plans',
  CheckoutComplete = '/pricing-and-plans/checkout-complete',
}
